import axios from 'axios'

const apiUrl = process.env.VUE_APP_API_URL
const instance = axios.create({
  baseURL: apiUrl
})

instance.interceptors.request.use(config => {
  config.baseURL += config.version || process.env.VUE_APP_API_VERSION

  return config
})

export default instance
